import { 
  collection, 
  addDoc, 
  updateDoc, 
  deleteDoc, 
  doc, 
  getDocs, 
  query, 
  where,
  Timestamp 
} from 'firebase/firestore';
import { db } from '../config/firebase';
import { Note } from '../types/Note';

const NOTES_COLLECTION = 'notes';

export const noteService = {
  // Create a new note
  async createNote(note: Omit<Note, 'id'>): Promise<string> {
    console.log('Creating note in Firestore...');
    try {
      const notesCollection = collection(db, NOTES_COLLECTION);
      console.log('Collection reference created');
      
      const docRef = await addDoc(notesCollection, {
        ...note,
        createdAt: Timestamp.fromDate(note.createdAt),
        updatedAt: Timestamp.fromDate(note.updatedAt)
      });
      console.log('Document added with ID:', docRef.id);
      return docRef.id;
    } catch (error) {
      console.error('Error in createNote:', error);
      throw error;
    }
  },

  // Get all notes for a user
  async getUserNotes(userId: string): Promise<Note[]> {
    const q = query(
      collection(db, NOTES_COLLECTION),
      where('userId', '==', userId)
    );
    const querySnapshot = await getDocs(q);
    return querySnapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data(),
      createdAt: doc.data().createdAt.toDate(),
      updatedAt: doc.data().updatedAt.toDate()
    })) as Note[];
  },

  // Update a note
  async updateNote(noteId: string, note: Partial<Note>): Promise<void> {
    const noteRef = doc(db, NOTES_COLLECTION, noteId);
    await updateDoc(noteRef, {
      ...note,
      updatedAt: Timestamp.fromDate(new Date())
    });
  },

  // Delete a note
  async deleteNote(noteId: string): Promise<void> {
    const noteRef = doc(db, NOTES_COLLECTION, noteId);
    await deleteDoc(noteRef);
  }
}; 